import css from 'styled-jsx/css';

const colors = {
  ywgPinkishOrange: '#ff794a',
  ywgPinkishOrangeStrong: '#dd390e',
  ywgPinkishOrangeSecondary: '#fff1ec',
  ywgPinkishOrangeStrongFilter:
    'invert(0.5) sepia(0.6) saturate(120) hueRotate(370deg)',
  ywgPinkishOrangeRgb: '255, 121, 74',
  ywgPinkishOrangeShadow: '#ff794a',
  ywgNavy: '#01244b',
  ywgNavyLight: '#47677f',
  ywgNavyDark: '#001d3d',
  ywgNavyRgb: '1, 36, 75',
  ywgBannerBackgroundRgb: '56, 64, 143',
  ywgVeryLightBlue: '#e8ebef',
  ywgVeryLightPink: '#cecece',
  ywgPaleGrey: '#f2f4f6',
  ywgPaleGreyTwo: '#f7f8f9',
  warmGrey15: 'rgba(121, 121, 121, 0.15)',
  backdrop: 'rgba(53, 64, 82, 0.25)',
  boxShadow: 'rgba(53, 64, 82, 0.5)',
  marine: '#031d5b',
  ywgPrimary: '#ff794a',
  ywgPrimaryFilter: 'invert(0.5) sepia(0.6) saturate(80) hueRotate(370deg)',
  ywgSecondary: '#01244b',
  ywgTertiary: 'white',
  ywgFacebook: '#355f9f',
  error: '#ff5454',
  valid: '#3ac450'
};

const fonts = {
  primaryFont: 'Quicksand, sansSerif',
  secondaryFont: 'Lato, sansSerif'
};

const dimensions = {
  ywgSectionMaxWidth: '1150px',
  ywgProfileMaxWidth: '720px',
  ywgSectionSurveyMaxWidth: '615px',
  ywgFormSpacing: '18px'
};

const globalStyles = css.global`
  body {
    color: ${colors.ywgNavy};
    background-color: ${colors.ywgPaleGreyTwo};
    font-family: ${fonts.primaryFont};
  }

  a {
    color: ${colors.ywgPinkishOrangeStrong};
  }

  p {
    font-family: ${fonts.secondaryFont};
  }
  ul,
  ol,
  li,
  dl,
  dt,
  dd {
    font-family: ${fonts.secondaryFont};
  }
`;

export { globalStyles, colors, fonts, dimensions };
